export const systemConfigKeyEnum = {
    COMPANY_NAME: 'companyName',
    APP_NAME: 'appName',
    LOGO: 'logo',
    LOGO_SMALL: 'logoSmall',
    COMPANY_PHONE: 'companyPhone',
    COMPANY_ADDRESS: 'companyAddress',
    SUPPORT_PHONE: 'supportPhone',
    ENVIRONMENT: 'environment',
    ANNECY_TRANSFER_COEF: 'annecyTransferCoef',
    LARGE_JOURNEY_PRICE: 'largeJourneyPrice',
    CURRENCY_SYMBOL: 'currencySymbol',
    DISTANCE_UNIT: 'distanceUnit',
    DEFAULT_WORKER_WORK_TIME: 'defaultWorkerWorkTime',
    DEFAULT_DRIVER_WORK_TIME: 'defaultDriverWorkTime',
    DEFAULT_WORKER_BREAK_TIME: 'defaultWorkerBreakTime',
    DEFAULT_DRIVER_BREAK_TIME: 'defaultDriverBreakTime',
    OVERTIME_BUFFER_HOURS: 'overtimeBufferHours',
    DEFAULT_TEMPWORKER_PRICE: 'defaultTempWorkerUnitPrice',
    PAYROLL_MEAL_BASKET_CODE: 'payrollMealBasketCode',
    PAYROLL_PHONE_ALLOWANCE_CODE: 'payrollPhoneAllowanceCode',
    PAYROLL_PHONE_ALLOWANCE_AMOUNT: 'payrollPhoneAllowanceAmount',
    PAYROLL_LONG_DISTANCE_CODE: 'payrollLongDistanceCode',
    APP_WEB_URL: 'appWebUrl',
};

export const systemConfigGroupEnum = {
    COMPANY: 'company',
    APP: 'app',
    SUPPORT: 'support',
    ENV: 'env',
    PRICING: 'pricing',
    TIME: 'time',
};
